import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react"
import { useUser } from "stores/useUser";
import { loginRequest, loginRequestMS } from "../authConfig";
import api from "./api";
import graph from "./graph";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

interface MSContextProps {
    children: React.ReactNode
}
export function MSContext({children}: MSContextProps) {
    const setUser = useUser(state => state.setUser);
    const navigate = useNavigate();
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const [logged, setLogged] = useState(false);

    async function handleLogin() {
        if (account && instance) {
            try {
                const tokenMs = await instance.acquireTokenSilent(loginRequestMS)
                graph.defaults.headers["Authorization"] = `Bearer ${tokenMs.accessToken}`;
                const token = await instance.acquireTokenSilent(loginRequest)
                api.defaults.headers["Authorization"] = `Bearer ${token.accessToken}`;
                try
                {
                    const res = await api.get(`/auth/microsoft`)
                    setUser(res.data);
                    //login in api and set user
                    setLogged(true);
                }
                catch
                {
                    instance.setActiveAccount(null)
                    alert("Conta não localizada");
                    navigate("/");
                }
            }
            catch(e) {
                await instance.logout();
                navigate("/login");
            }
        }
    }
    useEffect(() => {
        if (instance) {
            if(account === null) {
                navigate("/");
            }
            handleLogin();
        }
    }, [account])

    if (!logged) {
        return <div className="h-screen w-screen flex flex-col gap-4 justify-center items-center bg-zinc-100">
            <img className="w-12" src="https://cdn.brandfetch.io/microsoft.com/w/512/h/512/symbol" alt="Microsoft Logo"/>
            <Loader2 className="animate-spin text-zinc-400" />
        </div>
    }
    
    return <>
        {children}
    </>
}